import ApiServices, { LOAD_ORDER_EXPORT_TASKS} from "../config/ApiServices";
import api from "../utils/api";

export class LoadCustomOrderExportTasksEvent {
    params = null;
    constructor(params?: any) {
        this.params = params || {};
    }

    static getEventName() {
        return 'LoadCustomOrderExportTasksEvent';
    }
}


export class LoadCustomOrderExportTasksEventListener {
    dispatcher;

    constructor(dispatcher = null) {
        this.dispatcher = dispatcher;
    }

    async handle(event) {
        let apiServices = ApiServices;
        let res = await api(apiServices[LOAD_ORDER_EXPORT_TASKS], event.params);
        if (res['status']) {
            return res;
        }else{
            return false;
        }
    }

    async after(event) {

    }
}